import type { OrderDetails } from "@/store/types/order";
import type { OrderContactDto } from "./types";

export function contactDtoToOrder(
  contact: OrderContactDto,
  order: OrderDetails,
) {
  const billing = contact.billingAddresses[0];
  const shipping = contact.shippingAddresses[0];
  let updatedOrder: OrderDetails = {
    ...order,
    isActive: true,
    emailAddress: contact.email,
    phoneNumber: contact.phoneNumber,
    ada: contact.ada,
    sameAsBilling: contact.sameAsBillingAddress,
  };

  if (billing != null) {
    updatedOrder = {
      ...updatedOrder,
      billingAddressId: billing.id,
      billingAllowPo: billing.allowPo,
      billingBusinessName: billing.businessName,
      billingCity: billing.city,
      billingName: billing.name,
      billingPostalCode: billing.postalCode,
      billingOptionalUnit: billing.unitSuiteEtc,
      billingProvince: billing.province,
      billingStreetAddress: billing.streetAddress,
    };
  }

  if (shipping != null) {
    updatedOrder = {
      ...updatedOrder,
      shippingAddressId: shipping.id,
      shippingBusinessName: shipping.businessName,
      shippingCity: shipping.city,
      shippingName: shipping.name,
      shippingStreetAddress: shipping.streetAddress,
      shippingOptionalUnit: shipping.unitSuiteEtc,
      shippingPostalCode: shipping.postalCode,
      shippingProvince: shipping.province,
    };
  }

  return updatedOrder;
}
